import { CmsFooterContactsProperties } from '../Models/CmsFooterContactsProperties';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgModule } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CMSService } from '../Services/cms.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-cms-sub-fcontacts',
  templateUrl: './cms-sub-fcontacts.component.html',
  styleUrls: ['./cms-sub-fcontacts.component.css']
})
@NgModule({ imports: [FormsModule] })
export class CmsSubFContactsComponent {
  fContactsObj = new CmsFooterContactsProperties();
  public Type: string;
  public Details: string;
  public responseMessage: string;
  constructor(private userService: CMSService, public cmsService: CMSService, private http: HttpClient) { }
  ngOnInit() {
    this.LoadEditableData();
  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("serialNo") != undefined || localStorage.getItem("serialNo") != null) {
        let sr = Number(localStorage.getItem("serialNo"));
        if (sr != 0 || sr != undefined) {
          this.userService.getFooterContactsById(sr).subscribe((data) => {
            this.fContactsObj = data[0] as CmsFooterContactsProperties;
            localStorage.removeItem("serialNo");
          });
        }
      }
    }
    catch (e) {
      //console.log(e);
    }
  }
  onSubmit() {
    if (this.fContactsObj.sr == 0 || this.fContactsObj.sr ==null) {
      this.userService.createFooterContacts(this.fContactsObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data inserted Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while inserting data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }
    else {
      this.userService.updateFooterContacts(this.fContactsObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Data updated Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while updating data :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }
  }
  cancel() {
    this.fContactsObj = new CmsFooterContactsProperties();
  }
}
